/**
 * `Project.customer` fields saved by the block project-customer-tax-bank. Must match
 * `ProjectCustomerTaxBankInput` in the API schema.
 */
export const PROJECT_CUSTOMER_TAX_BANK_INPUT_FIELDS = [
  'taxNumber',
  'bank',
  'iban',
  'bic',
  'accountHolder',
];

/**
 * `ProjectCustomerTaxBankInput` from the block object (or the stored project): the five fields
 * of `customer`, a missing field as `null`.
 */
export const toProjectCustomerTaxBankInput = (project) => {
  const customer = project.customer ?? {};

  return Object.fromEntries(
    PROJECT_CUSTOMER_TAX_BANK_INPUT_FIELDS.map((field) => [field, customer[field] ?? null])
  );
};
